import axios from 'axios';
import { SlideTemplate, PPTemplateParams } from '../types/api';
import { Slide } from '../state/editorTypes';

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_SERVER_URL}/api/report/`
});

export const getTemplate = (params: PPTemplateParams) =>
  api
    .get<{ templateName: string; pages: Slide[] }>('/template', { params })
    .then(res => ({ ...res.data, templateName: params.fileName }));
